import { mapTargetCTA, mapTargetLink } from '@/App.datalayer';
import { withGTMPipe } from '@/features/shared/HOCs/withGTM';
import { Dialog } from '@material-ui/core';
import React, { useEffect } from 'react';
import { PrivacyConsentModalContent } from './components/PrivacyConsentModalContent';
import {
  onDataLayerConsentModalActionCTAClick,
  onDatalayerConsentModalCTAClick,
  onDatalayerConsentModalLinkClick,
} from './PrivacyConsentModal.datalayer';
import { PrivacyConsentModalProps } from './PrivacyConsentModal.interfaces';

// The withGTM is applied with each configuration you register getting only one output component
const PrivacyConsentModalContentGTM = withGTMPipe(
  {
    onDatalayer: onDataLayerConsentModalActionCTAClick,
    config: { mapTarget: mapTargetCTA },
  },
  {
    onDatalayer: onDatalayerConsentModalCTAClick,
    config: { mapTarget: mapTargetCTA },
  },
  {
    onDatalayer: onDatalayerConsentModalLinkClick,
    config: { mapTarget: mapTargetLink },
  },
)(PrivacyConsentModalContent);

export const PrivacyConsentModal = ({ contentProps, open = false }: PrivacyConsentModalProps) => {
  useEffect(() => {
    setTimeout(() => {
      // hidden content for html tag, the default scroll hidden for the body does not work
      document.getElementsByTagName('html')[0].style.overflow = open ? 'hidden' : '';
    }, 100);
  }, [open]);

  return (
    <Dialog open={open} data-testid="portal-cookie-modal" disableEscapeKeyDown disableScrollLock>
      <PrivacyConsentModalContentGTM {...contentProps} />
    </Dialog>
  );
};
